import _rrule from '@wix/moment-js-rrule';
import * as moment from 'moment-timezone';
declare global {
  interface Window {
    Wix: any;
  }
}
//const Wix = window.Wix;
function generateTimeZoneDictionary(timezonesNames: string[]): object {
  interface timeZoneOptions {
    [key: string]: number;
  }
  const timeZones: timeZoneOptions = {};
  for (let i = 0; i < timezonesNames.length; ++i) {
    timeZones[timezonesNames[i]] = i;
  }
  return timeZones;
}

function getValByLanguages(val: string): number {
  interface languagesOptions {
    [key: string]: number;
  }
  const languagesId: languagesOptions = {
    English: 0,
    Dansk: 1,
    Deutsch: 2,
    Čeština: 3,
    Español: 4,
    Français: 5,
    Italiano: 6,
    日本語: 7,
    한국어: 8,
    Nederlands: 9,
    Norsk: 10,
    Polski: 11,
    Português: 12,
    Русский: 13,
    Svenska: 14,
    Türkçe: 15,
    עברית: 16,
    中文: 17,
    ไทย: 18,
    Український: 19,
    TiếngViệt: 20,
    'Bahasa Indonesia': 21,
  };
  return languagesId[val] || 0;
}

function getLanguagesByVal(val: number): string {
  const languages = [
    'English',
    'Dansk',
    'Deutsch',
    'Čeština',
    'Español',
    'Français',
    'Italiano',
    '日本語',
    '한국어',
    'Nederlands',
    'Norsk',
    'Polski',
    'Português',
    'Русский',
    'Svenska',
    'Türkçe',
    'עברית',
    '中文',
    'ไทย',
    'Український',
    'TiếngViệt',
    'Bahasa Indonesia',
  ];

  const defaultLocale = window && window.Wix && window.Wix.Utils.getLocale();
  //@ts-ignore
  const defaultLanguage = getLanguagesByLocale(defaultLocale);

  return languages[val] || defaultLanguage;
}
function getLanguagesByLocale(locale: string): string {
  const defaultLocale = window && window.Wix && window.Wix.Utils.getLocale();
  interface languagesOptions {
    [key: string]: string;
  }
  const languages: languagesOptions = {
    en: 'English',
    da: 'Dansk',
    de: 'Deutsch',
    cs: 'Čeština',
    es: 'Español',
    fr: 'Français',
    it: 'Italiano',
    ja: '日本語',
    ko: '한국어',
    nl: 'Nederlands',
    nb: 'Norsk',
    pl: 'Polski',
    pt: 'Português',
    ru: 'Русский',
    sv: 'Svenska',
    tr: 'Türkçe',
    he: 'עברית',
    zh: '中文',
    th: 'ไทย',
    uk: 'Український',
    vi: 'TiếngViệt',
    id: 'Bahasa Indonesia',
  };

  return languages[locale] || languages[defaultLocale];
}

function getLocaleById(val: number): string {
  const languages = [
    'en',
    'da',
    'de',
    'cs',
    'es',
    'fr',
    'it',
    'ja',
    'ko',
    'nl',
    'nb',
    'pl',
    'pt',
    'ru',
    'sv',
    'tr',
    'he',
    'zh',
    'th',
    'uk',
    'vi',
    'id',
  ];
  return languages[val] || 'en';
}
function getIdByLocale(val: string): number {
  const languages = [
    'en',
    'da',
    'de',
    'cs',
    'es',
    'fr',
    'it',
    'ja',
    'ko',
    'nl',
    'nb',
    'pl',
    'pt',
    'ru',
    'sv',
    'tr',
    'he',
    'zh',
    'th',
    'uk',
    'vi',
    'id',
  ];
  return languages.indexOf(val) || 0;
}

export {
  getIdByLocale,
  getLanguagesByLocale,
  getValByLanguages,
  getLanguagesByVal,
  getLocaleById,
  generateTimeZoneDictionary,
};
